import { render } from "./textSections.vue?vue&type=template&id=0c1c2b8b&scoped=true"
import script from "./textSections.vue?vue&type=script&lang=js"
export * from "./textSections.vue?vue&type=script&lang=js"

import "./textSections.vue?vue&type=style&index=0&id=0c1c2b8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1c2b8b"]])

export default __exports__